import { Checkbox, HStack, Image, Pressable, Spacer, Text } from 'native-base';
import PropTypes from 'prop-types';
import React from 'react';

function Face({ checked, face, onCheck }) {
  return (
    <Pressable onPress={onCheck}>
      <HStack alignItems="center" py="1">
        <Image
          source={face.image}
          alt="NA"
          width="120"
          height="70"
          borderRadius="10"
          mr="10"
        />
        <Text fontSize="xl" bold>
          {face.display}
        </Text>
        <Spacer />
        <Checkbox
          colorScheme="green"
          isChecked={checked}
          onChange={onCheck}
          size="md"
          accessibilityLabel="Marquer comme donné"
        />
      </HStack>
    </Pressable>
  );
}

Face.propTypes = {
  checked: PropTypes.bool.isRequired,
  face: PropTypes.object.isRequired,
  onCheck: PropTypes.func.isRequired,
};

export default Face;
